import Flex from 'quarks/Flex';
import Link from 'quarks/Link';
import Text from 'quarks/Text';

import richTextParser from 'utils/richTextParser';

import type { ContentfulComponentBasicCard } from 'graphqlTypes';
import type { FC } from 'react';

interface TakeawayCardProps {
  card?: ContentfulComponentBasicCard;
  href: string;
}

const TakeawayCard: FC<TakeawayCardProps> = ({ card, href, ...props }) => (
  <Link
    href={href}
    textColor="gray-900"
    textDecoration="none"
    display="flex"
    flexDirection="column"
    boxShadow="0 16px 32px rgb(75 77 82 / 24%)"
    paddingAll={32}
    borderRadius="4px"
    minHeight="250px"
    transition="all .2s ease-in"
    hover={{
      transform: 'translateY(-8px)',
      boxShadow: '-1px 16px 20px rgb(0 0 0 / 25%)',
    }}
    width="100%"
    md={{
      width: '450px',
    }}
    xl={{
      width: '100%',
      minHeight: '304px',
    }}
    {...props}
  >
    <Flex
      width="44px"
      height="44px"
      backgroundColor="common-black"
      borderRadius="30px"
      justifyContent="center"
      alignItems="center"
      marginBottom={16}
    >
      <Text textStyle="xl" fontWeight="bold" textColor="common-white">
        {card?.category?.name || ''}
      </Text>
    </Flex>
    <Flex>{card?.body && richTextParser(card.body)}</Flex>
  </Link>
);

export default TakeawayCard;
